// Edit, add or remove quotes here; the hero rotates through them in order.
export const QUOTES = [
  { text: "Design is not just what it looks like and feels like. Design is how it works.", author: "Steve Jobs" },
  { text: "Nothing in, nothing out.", author: "Paul Bracy" },
  { text: "Good design is good business.", author: "Thomas J. Watson Jr." },
  { text: "A business with no sign is a sign of no business.", author: "Ol’ Kenny Smith" },
  { text: "Content is king.", author: "Bill Gates" },
  { text: "I’m not a businessman, I’m a business, man.", author: "Jay-Z" },
  { text: "I’ve failed over and over and over again in my life. And that is why I succeed.", author: "Michael Jordan" },
  { text: "Men lie, women lie, numbers don’t.", author: "Jay-Z" },
  { text: "Talent wins games, but teamwork and intelligence win championships.", author: "Michael Jordan" },
  { text: "If you are not embarrassed by the first version of your product, you’ve launched too late.", author: "Reid Hoffman" },
  { text: "Do what you do so well that they will want to see it again and bring their friends.", author: "Walt Disney" },
];
